import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { DomainSettingsSsoProvider } from '@rossum/api-client/internal';
import { useApiClient } from '../../lib/apiClient';

export const QUERY_KEY_DOMAIN_SETTINGS = 'domain-settings';

export type SsoProvider = DomainSettingsSsoProvider;

type UseDomainSettingsParams = {
  domain: string;
};

export const useDomainSettings = ({ domain }: UseDomainSettingsParams) => {
  const api = useApiClient();

  return useQuery({
    queryKey: [QUERY_KEY_DOMAIN_SETTINGS, domain] as const,
    queryFn: () => api.request(endpoints.internal.domainSettings({ domain })),
  });
};
